import React from 'react';
import { Helmet } from 'react-helmet';
import FormComponent from '../components/Form/FormComponent';

const Home = () => {
  const canonicalUrl = 'https://adobe.utmsmartmanager.com/';

  // Keep this aligned with public/index.html so you don't emit competing descriptions.
  // (React-snap will include both the static and helmet tags in build/index.html.)
  const metaDescription =
    'Build Adobe CID tracking codes and campaign URLs for Adobe Analytics. Free builder for cleaner s.campaign inputs, more consistent teams, and a clear path to governed workflows.';

  const ogTitle = 'Free Adobe CID Builder for Adobe Analytics | UTM Smart Manager';
  const ogDescription =
    'Generate Adobe CID tracking codes and campaign URLs for Adobe Analytics. Keep s.campaign inputs cleaner, teams more consistent, and reporting easier to trust.';

  return (
    <div>
      <Helmet>
        <title>Free Adobe CID Builder for Adobe Analytics | UTM Smart Manager</title>

        {/* ✅ Canonical: prevents duplicate indexing across variants */}
        <link rel="canonical" href={canonicalUrl} />

        {/* ✅ Primary meta description (aligned with public/index.html) */}
        <meta name="description" content={metaDescription} />

        {/* ✅ Indexing directives (safe defaults) */}
        <meta
          name="robots"
          content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1"
        />

        {/* ✅ Open Graph (sharing + consistency) */}
        <meta property="og:title" content={ogTitle} />
        <meta property="og:description" content={ogDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />

        {/* ✅ Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={ogTitle} />
        <meta name="twitter:description" content={ogDescription} />

        {/* Additional tags as required */}
      </Helmet>

      <FormComponent />
    </div>
  );
};

export default Home;